import { useState, useEffect } from 'react'
import { VENDER_PAGEVIEW } from './../constants'
import { GtmAgent } from './GtmAgent'

export const useGtmVenderPageView = (vender, options = {}) => {
  const { enabled = true } = options
  const [initialPageViewSent, setInitialPageViewSent] = useState(false)
  useEffect(() => {
    if (enabled && !initialPageViewSent && vender) {
      GtmAgent.directSendToGTM({
        event: VENDER_PAGEVIEW,
        living_partner_id: vender.urlId,
        living_partner_name: vender.name,
        living_partner_catlog: vender.serviceClassifications || [],
      })
      setInitialPageViewSent(true)
    }
  }, [enabled, vender, initialPageViewSent])
}
